import * as React from 'react';
import { useRef } from 'react';
import TopBar from '../components/molecules/TopBar';
import * as _ from 'underscore';
import TopBarHomeButton from '../components/atoms/TopBarHomeButton';
import ModuleOverviewItem from '../components/organisms/Modules/ModuleOverview/ModuleOverviewItem';
import { ModuleStateDB } from '../data/datatypes';
import { getAllModules, getAllModuleStates } from '../services/DBService/DbService';
import TopBarTutorialButton from '../components/atoms/TopBarTutorialButton';
import { useAppSelector } from '../store/hooks';
import { useSearchParams } from 'react-router-dom';
import LoadingScreen from '../components/atoms/LoadingScreen';
import { moduleIsVisibleForUser } from 'src/services/DecisionTreeService/DecisionTreeService';
import { ModuleDataDB } from '@app/common';

const ModuleOverview = () => {
    const [ modules, setModules ] = React.useState<ModuleDataDB[]>([]);
    const [ moduleStates, setModuleStates ] = React.useState<ModuleStateDB[]>([]);
    const config = useAppSelector(state => state.globalState.config);
    const userProperties = useAppSelector(state => state.globalState.user?.userProperties);
    const userStartDate = useAppSelector(state => state.globalState.user?.startDate);

    const scrollRef = useRef<HTMLDivElement>(null);
    const [searchParams, ] = useSearchParams();

    const hasVisibleModules = _.some(modules, module => moduleIsVisibleForUser(module, moduleStates.find(s => s._id === module._id)?.modifiers || [], modules, userStartDate, userProperties || []))

    React.useEffect(() => {
        const fetchModules = async () => {
            const fetchedModules = await getAllModules();
            const fetchedStates = await getAllModuleStates();
            const sortedModules = [ ...fetchedModules ].sort((left, right) => {
                const leftPriority = left.sortPriority ?? Number.MAX_SAFE_INTEGER;
                const rightPriority = right.sortPriority ?? Number.MAX_SAFE_INTEGER;

                if (leftPriority !== rightPriority) {
                    return leftPriority - rightPriority;
                }

                return left._id.localeCompare(right._id);
            });

            setModules(sortedModules);
            setModuleStates(fetchedStates);
        };
        fetchModules();
    }, []);

    let moduleContent = (
        <LoadingScreen message="Lade Module...  Wenn die Module nicht laden, starte bitte die App einmal neu."/>
    );
    if (modules.length > 0) {
        const moduleItems = modules.map(module => {
            const item = <ModuleOverviewItem 
                key={module._id}
                moduleData={module}
                moduleState={moduleStates.find(s => s._id === module._id)}
                allModules={modules}
                userStartDate={userStartDate}
                userProperties={userProperties || []}
            />;

            if (module._id === searchParams.get('scrollTo')) {
                return <div ref={scrollRef} key={module._id}>
                    {item}
                </div>;
            } else {
                return item;
            }

        });
        moduleContent = <>{moduleItems}</>;
    }
    if (!hasVisibleModules) {
        moduleContent = <p style={{ textAlign: 'center', marginTop: '0.5rem' }}>Sie haben im Moment keine Fragebögen zum Ausfüllen.</p>
    }

    React.useEffect(() => {
        if (scrollRef !== undefined && scrollRef.current !== null) {
            scrollRef.current.scrollIntoView();
        }
    }, [scrollRef, modules]);

    const topBarRightButtons: JSX.Element[] = [];

    if (userProperties && !userProperties.includes('DO_TUTORIAL') && config?.useTutorial) {
        topBarRightButtons.push(<TopBarTutorialButton />);
    }

    return (
        <div className="content mod-overview">
            <TopBar
                title={config?.homeMenuItems['modules']?.customMenuLabel || 'Modulübersicht'}
                icon={'icon_modules.svg'}
                leftButtons={[<TopBarHomeButton />]}
                rightButtons={topBarRightButtons}
            />
            <div className="content-container content-mod-overview">
                {moduleContent}
            </div>
        </div>
    );
};
export default ModuleOverview;